module.exports = __webpack_public_path__ + "img/logo.f07afdb9.png";